export const communityRoutes = [
  'home.community',
  'home.community.featured',
  'home.community.projects',
  'home.community.topics',
  'home.community.tasks',
  'home.community.members',
  'channel',
  'channel.stories',
  'channel.threads',
  'channel.collections',
  'profile.story',
  'initiative.story',
  'profile.collection',
];

export const conditionalProjectRoutes = [
  'profile.project',
  'profile.project.files',
  'profile.project.issues',
  'profile.project.issue',
  'profile.project.file',
  'profile.project.version.file',
  'initiative.project',
  'initiative.project.files',
  'initiative.project.issues',
  'initiative.project.issue',
  'initiative.project.file',
  'initiative.project.version.file',
  'initiative.project.contribution',
];

export const conditionalCommunityRoutes = [
  'profile',
  'profile.projects',
  'profile.stories',
  'profile.threads',
  'profile.collections',
  'initiative',
  'initiative.projects',
  'initiative.stories',
  ...conditionalProjectRoutes,
];
